import { useState } from 'react'
import styled from 'styled-components'
import Popover from '../../dataDisplay/Popover'
import { Button, Text } from '../../general'
import { ButtonProps } from '../../general/Button/Button'
import Divider from '../../layout/Divider/Divider'
import { useUiKitContext } from '../../utils/UiKitProvider/UiKitProvider'

const Popconfirm = (props: PopConfirmProps) => {
  const { translation: t } = useUiKitContext()
  const {
    cancelText = t('general.buttons.cancel'),
    confirmText = t('general.buttons.confirm'),
    title,
    description = '',
    children,
    onConfirm,
    disabled = false,
    ...restProps
  } = props

  const [open, setOpen] = useState<boolean | undefined>(false)

  const onOpenChange = (value: boolean) => {
    if (disabled) {
      return
    }

    setOpen(value)
  }

  const onCancelHandler = () => {
    onOpenChange(false)
  }
  const onConfirmHandler = () => {
    onOpenChange(false)
    onConfirm()
  }

  return (
    <Popover
      onOpenChange={onOpenChange}
      open={open}
      title={title}
      trigger="click"
      {...restProps}
      content={
        <>
          <StyledDivider />
          <Text>{description}</Text>
          <ControlsWrapper>
            <Button onClick={onCancelHandler} variant="default">
              {cancelText}
            </Button>
            <Button onClick={onConfirmHandler} variant="danger">
              {confirmText}
            </Button>
          </ControlsWrapper>
        </>
      }
    >
      {children}
    </Popover>
  )
}

export type PopConfirmProps = {
  cancelText?: string
  confirmText?: string
  title?: string
  description?: string
  children: React.ReactChild
  onConfirm: () => void
  disabled?: boolean
}

const ControlsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 8px;

  margin-top: 10px;
`

const StyledDivider = styled(Divider)`
  margin-bottom: 10px;
`

export default Popconfirm
